(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const faqSection = document.querySelector('.faq-section');
    if (!faqSection) return;

    const tabs = faqSection.querySelectorAll('.faq__tab');
    const faqItems = faqSection.querySelectorAll('.faq__item');
    const questions = faqSection.querySelectorAll('.faq__question');

    // Initialize: Show first category's items
    function initializeFAQ() {
      const firstTab = tabs[0];
      if (firstTab) {
        const firstCategory = firstTab.dataset.category;
        filterByCategory(firstCategory);
      } else {
        // If no tabs, show all items
        faqItems.forEach(item => {
          item.classList.add('faq__item--visible');
        });
      }
    }

    // Filter FAQ items by category
    function filterByCategory(categoryId) {
      if (!categoryId) {
        // If no category ID, show all items
        faqItems.forEach(item => {
          item.classList.add('faq__item--visible');
        });
        return;
      }

      faqItems.forEach(item => {
        const itemCategory = item.dataset.category;
        if (itemCategory === categoryId) {
          item.classList.add('faq__item--visible');
        } else {
          item.classList.remove('faq__item--visible');
          // Close any open items when switching categories
          const question = item.querySelector('.faq__question');
          if (question) {
            question.setAttribute('aria-expanded', 'false');
          }
        }
      });
    }

    // Tab click handler
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        // Update active tab
        tabs.forEach(t => t.classList.remove('faq__tab--active'));
        this.classList.add('faq__tab--active');

        // Filter FAQ items
        const categoryId = this.dataset.category;
        filterByCategory(categoryId);
      });
    });

    // Accordion toggle handler
    questions.forEach(question => {
      question.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const answer = this.nextElementSibling;

        if (isExpanded) {
          // Close
          this.setAttribute('aria-expanded', 'false');
        } else {
          // Close other open items in the same category (optional - remove if you want multiple open)
          const currentItem = this.closest('.faq__item');
          const currentCategory = currentItem ? currentItem.dataset.category : null;
          
          questions.forEach(q => {
            const item = q.closest('.faq__item');
            if (item && item.dataset.category === currentCategory && q !== this) {
              q.setAttribute('aria-expanded', 'false');
            }
          });

          // Open this one
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Initialize on load
    initializeFAQ();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
